<template>
	<div v-if="editField" class="display-flex flex-column pa-3">
		<div class="header-container display-flex flex-row flex-align-center flex-justify-space-between">
			<div class="header-title my-1">
				<Row>
					{{ fieldConf.settingsTitle }}
					<MaybeUpgradeRequiredIndicator :billingFeatureId="fieldConf.billingFeatureId" v-if="fieldConf.billingFeatureId">
						<template #default="{ indicator, isUpgradeRequired }">
							<div class="flex-space-between--center mr-3">
								<div class="pl-2" v-if="isUpgradeRequired && isCustomerFeature">
									<component :is="indicator" :billingFeatureId="fieldConf.billingFeatureId" iconOnly canBuild />
								</div>
							</div>
						</template>
					</MaybeUpgradeRequiredIndicator>
				</Row>
			</div>
			<div v-if="!isMiniApp" class="conf-buttons flex-centerize">
				<RoundButton @click="deleteWidgetField">
					<SIcon name="trash" class="si"></SIcon>
				</RoundButton>
				<RoundButton class="ml-2 mr-2" @click="duplicateField">
					<SIcon name="duplicate" class="si"></SIcon>
				</RoundButton>
				<MoveConfigurationDropdown left :isGeneralConfiguration="isGeneralConfiguration" v-if="showMoveConfigurationOption" />
			</div>
		</div>
		<component :previousSteps="previousSteps" class="pb-9" :is="fieldConf.component" :field="editField" />
	</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

import widgetFieldTypes from './widgetFieldTypes';
import MaybeUpgradeRequiredIndicator from '@/components/Billing/MaybeUpgradeRequiredIndicator.vue';
import { NONE_INTERFACE_CONFIGURATION_ONLY_FIELDS } from '@/components/BlockEditorWidget/widgetFieldTypes.const';
import { editWorkflow } from '@/store/modules/selectedWorkflow/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import WorkflowService from '@/utils/WorkflowService';
import MoveConfigurationDropdown from '@/views/Flow/configurations/SetupMenu/CredentialsSelector/MoveConfigurationDropdown';
export default {
	name: 'BlockEditorWidgetFieldSettings',
	props: {
		previousSteps: { type: Object },
		isGeneralConfiguration: { type: Boolean },
		isConfigurationEditMode: { type: Boolean },
	},
	components: {
		MoveConfigurationDropdown,
		MaybeUpgradeRequiredIndicator,
	},
	computed: {
		...mapGetters('widgetEditor', ['editField']),
		...mapGetters('selectedNode', ['isMiniApp']),
		...mapGettersShorthand({ editWorkflow }),
		fieldConf() {
			return widgetFieldTypes[this.editField.field_type];
		},
		showMoveConfigurationOption() {
			return this.isConfigurationEditMode && !NONE_INTERFACE_CONFIGURATION_ONLY_FIELDS.includes(this.editField.field_type);
		},
		isCustomerFeature() {
			return WorkflowService.isCustomerFacingFeature(this.editWorkflow);
		},
	},
	methods: {
		...mapActions('widgetEditor', ['deleteWidgetField', 'duplicateField']),
	},
};
</script>
<style scoped lang="scss">
.header-title {
	color: #161b42;
	font-weight: 700 !important;
}
</style>
